import styles from './spinner.module.css'
import classNames from 'classnames';

export const Spinner = ({dark, ...props}) => {
  return (
    <span className={classNames(styles["loader"], dark ? styles["dark-loader"] : '')} {...props}></span>
  );
}
